module.exports = __webpack_public_path__ + "img/4.d120a8e2.png";